import { Tooltip, Zoom, Box } from "@mui/material";
import Icon from "../../Icon/Icon";
import { parseDateToLocalTZ } from "../../../helpers/dateTransform";

/**
 * Ícono de información que, al hacer hover, muestra la fecha/hora en la zona
 * horaria del navegador. Se coloca junto a las horas etiquetadas como "UTC"
 * para que cada usuario pueda ver su equivalente local.
 *
 * Se renderiza inline (span + svg) para poder colocarlo dentro de <p>/<span>
 * (p. ej. el `secondary` de MUI ListItemText) sin romper el anidamiento HTML.
 * @param {Object} param0
 * @param {String} param0.date Fecha cruda del backend (UTC, usualmente naive)
 * @param {String} param0.placement Posición del tooltip (default "top")
 * @param {Number} param0.size Tamaño del ícono en px (default 16)
 * @param {Object} param0.sx Estilos extra del contenedor del ícono
 * @returns {JSX.Element|null}
 */
export const UTCHint = ({ date, placement = "top", size = 16, sx = {} }) => {
  const text = parseDateToLocalTZ(date);
  if (!text) return null;

  return (
    <Tooltip
      title={text}
      placement={placement}
      arrow
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 150 }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          verticalAlign: "middle",
          cursor: "help",
          ml: 0.5,
          ...sx,
        }}
      >
        <Icon name="info_circle" size={size} color="#8AA1AC" />
      </Box>
    </Tooltip>
  );
};
